export const hero = {
  title: "A escola na natureza onde as crianças crescem felizes e seguras",
  subtitle: "Uma escola com um máximo de 80 crianças em Gondomar: inspiração Montessori, uma pessoa docente por cada 10-12 crianças, três línguas a conviver diariamente com o inglês como principal, e acreditação NEASC.",
  bookVisit: "Agendar visita",
  discoverGandara: "Descobrir Gándara"
};
